/**
 * The snapshot/period marker — same dot + label as StatBand's header, sized
 * to sit inline next to a section title, a table title or a KPI tile.
 * Requirements §5.1: a number's time basis travels with the number, so the
 * marker is one component rather than the copy-pasted span it used to be.
 */
const BandTag = ({ kind, label, meta }) => (
  <span className="stat-band__label" data-kind={kind}>
    <span className={`stat-band__dot stat-band__dot--${kind}`} />
    <h3 data-kind={kind}>{label}</h3>
    {meta && <span className="stat-band__meta">· {meta}</span>}
  </span>
);

export default BandTag;
